// How to show a signed-in player's name, everywhere it appears in this game.
//
// Three screens used to print `state.username` raw: mainMenuScreen's "Signed
// in as X", the in-game HUD corner in components.ts, and the Captain's
// Lounge's "Your own record, Captain X". `username` is whatever
// session.ashx returns for that field, which for a self-signup account with
// no nickname is the raw 32-hex opaque account key -- never meant to be
// read by a person, and exactly what a player saw as "Signed in as
// 4a6c5e1ca654e...".
//
// A thin wrapper around DrsAuth.formatPlayerName rather than a second
// implementation of the same regex: the shape test (is this 32 lowercase hex
// characters?) already lives in auth-client.js, shared with the account page
// and every other game's lab bar, and duplicating it here is how the two
// definitions quietly drift.

export interface FormattedPlayerName {
  text: string;
  /** True only for an opaque account key -- never for a nickname or a legacy account's own username. */
  opaque: boolean;
}

// window.DrsAuth comes from a script tag pointed at the shared auth host
// (see the /auth proxy in vite.config.ts) -- a real external dependency
// that can fail to load (offline, DNS, the host being down), and login is
// explicitly optional (design doc Section 13): the game must stay fully
// playable with no server reachable at all, so this can never be the
// thing that crashes boot.
export function formatPlayerName(name: string | null | undefined): FormattedPlayerName {
  if (!window.DrsAuth) return { text: name ?? "", opaque: false };
  return window.DrsAuth.formatPlayerName(name);
}

/** Sends the player to set a nickname, from wherever in the game they clicked "Change Name". */
export function goToChangeNickname(): void {
  window.location.href = "/auth/account.html?view=nickname";
}
